export enum Mode {
    comment = 'comment',
    message = 'message',
    action = 'action',
    story = 'story'
}
